import { render } from "./modal.vue?vue&type=template&id=af057400&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=af057400&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af057400"

export default script